module.exports = __webpack_public_path__ + "img/network.bdd91be0.svg";